module.exports = __webpack_public_path__ + "static/media/accordion-active-arrow.e1aba91c.svg";